export default __webpack_public_path__ + "static/media/imageLogin.3051ab0a.jpg";